export async function shipmentsGetAvailableShippingServicesUseCase(shipping_service, shipmentRepository) {
    
    const result = await shipmentRepository.get_ff_shipping_services(shipping_service);
    
    const entity = new shipmentRepository.model_shipping_services(result.data.success.arguments);
    
    if (!entity.isValid()) {
        throw new Error("Shipment shipping_services inválido");
    }

    return entity;
}